import common from '../language/en/common.json'
import login from '../language/en/login.json'
import report from '../language/en/report.json'
import fin from '../language/en/fin.json'
import fg from '../language/en/fg.json'
import tube from '../language/en/tube.json'
import search from '../language/en/search.json'
import header from '../language/en/header.json'
import plate from '../language/en/plate.json'
import button from '../language/en/button.json'
import home from '../language/en/home.json'
import menu from '../language/en/menu.json'
import sell from '../language/en/sell.json'
import systemInfo from '../language/en/systeminfo.json'
import master from '../language/en/masterData.json'
import setting from '../language/en/setting.json'
import share from '../language/en/share.json'
import user from '../language/en/user.json'
import reqDrawing from './en/reqDrawing.json'
import urlTranslate from './en/urlTranslate.json'

export default {
   ...common,
   ...login,
   ...report,
   ...fin,
   ...fg,
   ...tube,
   ...search,
   ...header,
   ...plate,
   ...button,
   ...home,
   ...menu,
   ...sell,
   ...systemInfo,
   ...master,
   ...setting,
   ...share,
   ...user,
   ...reqDrawing,
   ...urlTranslate
}


// WEBPACK FOOTER //
// ./src/wording/language/en.js